<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar class="toolbar-label">
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        id="close-modal-btn"
        data-cy="close-calendar-modal-button"
        (click)="cancel()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  class="calendar-container"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  [class.pronto-calendar]="isProntoAvailable"
  scroll-y="true"
>
  <div class="calendar-header">
    <h1 class="calendar-title">{{ title | translate }}</h1>
    <p class="calendar-date">
      <ion-icon name="calendar-outline"> </ion-icon>
      <span class="calendar-date-show">
        {{ 'i18n.common.dateSelect' | translate }}
      </span>
      <span *ngIf="!multiple" class="calendar-date-value">
        {{ currentDateSelected | date: 'MM/dd/yyyy' }}
      </span>
      <span *ngIf="multiple" class="calendar-date-value">
        {{
          currentDateRangeSelected
            ? (currentDateRangeSelected[0] | date: 'MM/dd/yyyy')
            : ''
        }}
      </span>
      <span *ngIf="multiple" class="calendar-date-value">
        {{
          currentDateRangeSelected && currentDateRangeSelected.length > 1
            ? ' to ' + (currentDateRangeSelected[1] | date: 'MM/dd/yyyy')
            : ''
        }}
      </span>
    </p>
  </div>
  <div class="calendar-body">
    <ion-datetime
      id="date"
      slot="content"
      size="cover"
      [presentation]="timeEnabled && !multiple ? 'date-time' : 'date'"
      [multiple]="multiple"
      [(ngModel)]="multiple ? currentDateRangeSelected : currentDateSelected"
      (ionChange)="handleValue($event)"
      [min]="minDate"
      [max]="maxDate"
      [dayValues]="dayValues"
      [isDateEnabled]="isDateEnabled"
      [highlightedDates]="prontoDates"
      mode="ios"
    >
    </ion-datetime>
    <div *ngIf="isProntoAvailable" class="calendar-date-options">
      <ion-item lines="none">
        <ion-icon
          name="ellipse"
          size="large"
          [style.color]="'#F3BA1633'"
        ></ion-icon>
        <p>
          {{ 'i18n.common.prontoDelivery' | translate }}
        </p>
      </ion-item>
      <ion-item lines="none">
        <ion-icon
          name="ellipse"
          size="large"
          [style.color]="'#DDE6D2'"
        ></ion-icon>
        <p>
          {{ 'i18n.common.standardDelivery' | translate }}
        </p>
      </ion-item>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        *ngIf="showClearButton"
        id="clear-date-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        data-cy="cancel-date-button"
        (click)="clearAll()"
        translate
      >
        {{ 'i18n.common.clearAll' }}
      </ion-button>
      <ion-button
        id="update-date-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        data-cy="submit-date-button"
        (click)="multiple ? sendRange() : sendDate()"
        translate
      >
        {{ 'i18n.common.apply' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
